import React, {Component} from 'react';
import {Switch, Route, Link} from 'react-router-dom';
import Styles from './style.css';
import HeaderDashboardOne from "../../components/header-dashboard-one/component";
import UserCampaignsRunning from "../../components/user-campaigns-running/component";
import UserCampaignsRunningEdit from "../../components/user-campaigns-running-edit/component";
import UserCampaignsHistory from "../../components/user-campaigns-history/component";
import UserCampaignsHistoryEdit from "../../components/user-campaigns-history-edit/component";
import UserBillingInvoices from "../../components/user-billing-invoices/component";
import UserBillingPayment from "../../components/user-billing-payment/component";
import UserProfile from "../../components/user-profile/component";
import UserInvite from "../../components/user-invite/component";
import UserSettings from "../../components/user-settings/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {langRegister} from "../../services/langRegister";
import HeaderMobileMenu from "../../components/header-mobile-menu/component";
import HeaderSignUpOne from "../../components/header-signup-one/component";
import {cartRegister} from "../../services/cartRegister";
import {quotesRegister} from "../../services/quotesRegister";
import {imagesRegister} from "../../services/imagesRegister";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import UserBillingInvoicesItem from "../../components/user-billing-invoices-item/component";
import {marketRegister} from "../../services/marketRegister";
import {dataRegister} from "../../services/dataRegister";
import {demoRegister} from "../../services/demoRegister";
import UserInsights from "../../components/user-insights/component";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import UserCampaignsArchived from "../../components/user-campaigns-archived/component";

class User extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            selected: "",
            dropdown: {
                campaigns: false,
                billing: false
            },
            user: {},
            campaigns_active: 0
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);
        this._setView();
        this._updateUser();
        this._resetSignUp();
        this._updateCampaigns();
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this._setView();
            window.scrollTo(0, 0);
        }
    }

    _updateUser() {
        let user = userRegister.get();
        if(user){
            this.setState({
                user: user,
                reseller: user.reseller,
                inhouse: user.inhouse
            });
        }
    }

    _updateCampaigns(){
        dataRegister.campaigns(salesChannelRegister.get("market"), langRegister.lang(), "running,terminated_ended,terminated_renew,terminated,auto_bill,ready,awaiting_payment,ended,ended_renew,archived").then((response) => {
            if(response.constructor === Array){
                let active = 0;
                let archived =  0;
                let history =  0;
                for(let i = 0; i < response.length; i++){
                    try{
                        if(response[i].status === "AWAITING_PAYMENT" || response[i].status === "RUNNING" || response[i].status === "AUTO_BILL" || response[i].status === "READY"){
                            active = active + 1;
                        }else if(response[i].status === "ENDED" || response[i].status === "ENDED_RENEW" || response[i].status === "TERMINATED" || response[i].status === "TERMINATED_ENDED" || response[i].status === "TERMINATED_RENEW"){
                            history = history + 1;
                        }else if(response[i].status === "ARCHIVED"){
                            archived = archived + 1;
                        }
                    }catch (e) {}
                }
                this.setState({campaigns_active: active, campaigns_history: history, campaigns_archived: archived, isLoading: false});
            }else{
                this.setState({isLoading: false});
            }
        }, (error) => {
            if(error.status === 401){
                this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + "/login");
            }else{
                this.setState({isLoading: false});
            }
        });
    }

    _setView(){
        try{
            this.setState({selected: this.props.location.pathname}, () => {
                if(this.state.selected === "/" + salesChannelRegister.get("market") + "/" + langRegister.lang() +  "/user/billing/payment" || this.state.selected === "/" + marketRegister.code() + "/" + langRegister.lang() +  "/user/billing/receipts"){
                    this.state.dropdown.billing = true;
                    this.setState({dropdown: this.state.dropdown});
                }else if(this.state.selected === "/" + salesChannelRegister.get("market") + "/" + langRegister.lang() +  "/user/campaigns/running" || this.state.selected === "/" + marketRegister.code() + "/" + langRegister.lang() +  "/user/campaigns/history" || this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/archived"){
                    this.state.dropdown.campaigns = true;
                    this.setState({dropdown: this.state.dropdown});
                }
            });
        }catch (error) {}
    }

    _resetSignUp() {
        cartRegister.remove();
        quotesRegister.remove();
        imagesRegister.remove();
    }

    _goTo(value){
        this.setState({selected: value}, () => {
            this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + value);
        });
    }

    _renderText(item) {
        return langRegister.get("user", item);
    }

    render() {
        return (
            <div>
                {
                    !this.state.isLoading &&
                    <div>
                        <span className={Styles.mobileMenu}>
                    <HeaderDashboardOne props={this.props}/>
                </span>
                        <div className={Styles.container}>
                            <div className={Styles.menu}>
                                <div className={Styles.menuHeader}>
                                    <img onClick={() => {
                                        if(this.props.location.pathname.indexOf("running") === -1){
                                            this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + "/user/campaigns/running");
                                        }else{
                                            this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang());
                                        }
                                    }} className={Styles.menuHeaderLogo} src={require("../../assets/images/logo-white.svg")}/>
                                </div>
                                <div onClick={() => {
                                    this.state.dropdown.campaigns = !this.state.dropdown.campaigns;
                                    this.setState({dropdown: this.state.dropdown})
                                }} className={Styles.menuItem}>
                                    <img className={Styles.menuItemIcon} src={require("../../assets/images/gloce-icon.svg")}/>
                                    <div className={Styles.menuItemTitle}>
                                        {this._renderText("item_1")}
                                    </div>
                                    <img
                                        className={
                                            cx(Styles.menuItemArrow,
                                                {
                                                    [Styles.menuItemArrowActive]: this.state.dropdown.campaigns,
                                                })
                                        } src={require("../../assets/images/arrow-icon-grey.svg")}/>
                                </div>

                                <div className={
                                    cx(Styles.menuDropdown,
                                        {
                                            [Styles.menuDropdownOpenCampaigns]: this.state.dropdown.campaigns,
                                        })
                                }>


                                    <div onClick={() => this._goTo("/user/campaigns/running")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: this.state.selected === "/" + salesChannelRegister.get("market") + "/" + langRegister.lang() +  "/user/campaigns/running",
                                                     [Styles.menuItemPassive]: this.state.dropdown.campaigns,
                                                 })
                                         }>
                                        {
                                            this.state.selected === "/" + salesChannelRegister.get("market") + "/" + langRegister.lang() +  "/user/campaigns/running" &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/flag-icon-white.svg")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_3")}
                                        </div>
                                        {
                                            this.state.campaigns_active > 0 &&
                                            <div className={cx(Styles.menuItemIndicator)}>
                                                {this.state.campaigns_active}
                                            </div>
                                        }
                                    </div>

                                    <div onClick={() => this._goTo("/user/campaigns/history")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: this.state.selected === "/" + salesChannelRegister.get("market") + "/" + langRegister.lang() +  "/user/campaigns/history",
                                                     [Styles.menuItemPassive]: this.state.dropdown.campaigns,
                                                 })
                                         }>
                                        {
                                            this.state.selected === "/" + salesChannelRegister.get("market") + "/" + langRegister.lang() +  "/user/campaigns/history" &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/arrow_down_white.png")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_4")}
                                        </div>
                                        {
                                            this.state.campaigns_history > 0 &&
                                            <div className={cx(Styles.menuItemIndicator, Styles.menuItemIndicatorOrange)}>
                                                {this.state.campaigns_history}
                                            </div>
                                        }
                                    </div>

                                    <div onClick={() => this._goTo("/user/campaigns/archived")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/archived",
                                                     [Styles.menuItemPassive]: this.state.dropdown.campaigns,
                                                 })
                                         }>
                                        {
                                            this.state.selected === "/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/archived" &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/cloud_icon.svg")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_12")}
                                        </div>
                                        {
                                            this.state.campaigns_archived > 0 &&
                                            <div className={cx(Styles.menuItemIndicator, Styles.menuItemIndicatorGrey)}>
                                                {this.state.campaigns_archived}
                                            </div>
                                        }
                                    </div>

                                </div>

                                <div onClick={() => {
                                    this.state.dropdown.billing = !this.state.dropdown.billing;
                                    this.setState({dropdown: this.state.dropdown})
                                }} className={Styles.menuItem}>
                                    <img className={Styles.menuItemIcon} src={require("../../assets/images/sheets_white_icon.png")}/>
                                    <div className={Styles.menuItemTitle}>
                                        {this._renderText("item_5")}
                                    </div>
                                    <img
                                        className={
                                            cx(Styles.menuItemArrow,
                                                {
                                                    [Styles.menuItemArrowActive]: this.state.dropdown.billing,
                                                })
                                        } src={require("../../assets/images/arrow-icon-grey.svg")}/>
                                </div>

                                <div className={
                                    cx(Styles.menuDropdown,
                                        {
                                            [Styles.menuDropdownOpen]: this.state.dropdown.billing,
                                        })
                                }>
                                    <div onClick={() => this._goTo("/user/billing/receipts")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: this.state.selected === "/" + salesChannelRegister.get("market") + "/" + langRegister.lang() +  "/user/billing/receipts",
                                                     [Styles.menuItemPassive]: this.state.dropdown.billing,
                                                 })
                                         }>
                                        {
                                            this.state.selected === "/" + salesChannelRegister.get("market") + "/" + langRegister.lang() +  "/user/billing/receipts" &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/price_white_icon.png")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_6")}
                                        </div>
                                    </div>

                                </div>

                                <div onClick={() => this._goTo("/user/profile")}
                                     className={
                                         cx(Styles.menuItem,
                                             {
                                                 [Styles.menuItemActive]: this.state.selected === "/" + salesChannelRegister.get("market") + "/" + langRegister.lang() +  "/user/profile",
                                             })
                                     }>
                                    {
                                        this.state.selected === "/" + salesChannelRegister.get("market") + "/" + langRegister.lang() +  "/user/profile" &&
                                        <div className={Styles.menuItemSelectedBorder}/>
                                    }
                                    <img className={Styles.menuItemIcon}
                                         src={require("../../assets/images/user-icon-white.svg")}/>
                                    <div className={Styles.menuItemTitle}>
                                        {this._renderText("item_7")}
                                    </div>
                                </div>

                                {
                                    false &&
                                    <div onClick={() => this._goTo("/user/invite")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: this.state.selected === "/" + salesChannelRegister.get("market")+ "/" + langRegister.lang() +  "/user/invite",
                                                 })
                                         }>
                                        {
                                            this.state.selected === "/" + salesChannelRegister.get("market") + "/" + langRegister.lang() +  "/user/invite" &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/heart-icon-white.svg")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_8")}
                                        </div>
                                    </div>
                                }

                                <div onClick={() => this._goTo("/user/settings")}
                                     className={
                                         cx(Styles.menuItem,
                                             {
                                                 [Styles.menuItemActive]: this.state.selected === "/" + salesChannelRegister.get("market") + "/" + langRegister.lang() +  "/user/settings",
                                             })
                                     }>
                                    {
                                        this.state.selected === "/" + salesChannelRegister.get("market") + "/" + langRegister.lang() +  "/user/settings" &&
                                        <div className={Styles.menuItemSelectedBorder}/>
                                    }
                                    <img className={Styles.menuItemIcon}
                                         src={require("../../assets/images/settings-icons-white.svg")}/>
                                    <div className={Styles.menuItemTitle}>
                                        {this._renderText("item_9")}
                                    </div>
                                </div>


                                {
                                    (this.state.reseller || this.state.inhouse) &&
                                    <div onClick={() => this._goTo("/user/insights")}
                                         className={
                                             cx(Styles.menuItem,
                                                 {
                                                     [Styles.menuItemActive]: this.state.selected === "/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + "/user/insights",
                                                 })
                                         }>
                                        {
                                            this.state.selected === "/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + "/user/insights" &&
                                            <div className={Styles.menuItemSelectedBorder}/>
                                        }
                                        <img className={Styles.menuItemIcon}
                                             src={require("../../assets/images/stats_icon.svg")}/>
                                        <div className={Styles.menuItemTitle}>
                                            {this._renderText("item_11")}
                                        </div>
                                    </div>
                                }

                            </div>
                            <div className={Styles.content}>
                                <Route exact path={this.props.match.url + "/campaigns/running"} component={UserCampaignsRunning}/>
                                <Route exact path={this.props.match.url + "/campaigns/running/:hash"} component={UserCampaignsRunningEdit}/>
                                <Route exact path={this.props.match.url + "/campaigns/archived"} component={UserCampaignsArchived}/>
                                <Route exact path={this.props.match.url + "/campaigns/history"} component={UserCampaignsHistory}/>
                                <Route exact path={this.props.match.url + "/campaigns/history/:hash"} component={UserCampaignsHistoryEdit}/>
                                <Route exact path={this.props.match.url + "/billing/receipts"} component={UserBillingInvoices}/>
                                <Route exact path={this.props.match.url + "/billing/receipts/:id"} component={UserBillingInvoicesItem}/>
                                <Route exact path={this.props.match.url + "/billing/payment"} component={UserBillingPayment}/>
                                <Route exact path={this.props.match.url + "/profile"} component={UserProfile}/>
                                <Route exact path={this.props.match.url + "/invite"} component={UserInvite}/>
                                <Route exact path={this.props.match.url + "/settings"} component={UserSettings}/>
                                <Route exact path={this.props.match.url + "/insights"} component={UserInsights}/>
                            </div>
                        </div>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                    </div>
                }
            </div>
        );
    }
}

/*
<div onClick={() => this._goTo("/user/billing/payment")}
                                 className={
                                     cx(Styles.menuItem,
                                         {
                                             [Styles.menuItemActive]: this.state.selected === "/user/billing/payment",
                                             [Styles.menuItemPassive]: this.state.dropdown.billing,
                                         })
                                 }>
                                {
                                    this.state.selected === "/user/billing/payment" &&
                                    <div className={Styles.menuItemSelectedBorder}/>
                                }
                                <img className={Styles.menuItemIcon}
                                     src={require("../../assets/images/flag-icon-white.svg")}/>
                                <div className={Styles.menuItemTitle}>
                                    payment
                                </div>
                            </div>
 */

export default User;


// WEBPACK FOOTER //
// ./src/pages/user/component.js